import {ConnectElementObservableValues} from './ConnectElementObservableValues';

export class ConnectElementAttributes extends ConnectElementObservableValues<
  Record<string, string>
> {}
